import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table6 = ({ masouliatMaliScore, setMasouliatMaliScore, reload }) => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)


  const [data, setData] = useState()
  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.masouliatManabeMali;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 8, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 16, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 24, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },

      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setMasouliatMaliScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "masouliatManabeMali": selectedItem }))
    }
  }, [reload])





  return (
    <div>

      <Row type={1}>
        <Column>سطح 1</Column>
        <Column>سطح 2</Column>
        <Column>سطح 3</Column>
        <Column>سطح 4</Column>
        <Column>سطح 5</Column>
      </Row>
      <Row>
        <Column isActive={masouliatMaliScore == 8}>8</Column>
        <Column isActive={masouliatMaliScore == 16}>16</Column>
        <Column isActive={masouliatMaliScore == 24}>24</Column>
        <Column isActive={masouliatMaliScore == 32}>32</Column>
        <Column isActive={masouliatMaliScore == 40}>40</Column>
      </Row>
    </div>
  );
};

export default Table6;
